import React from 'react';
import { MessageBanner } from '@folio/stripes/components';
import { t } from '../../../../services';
export var CrossTenantListWarning = function (_a) {
    var shouldShow = _a.shouldShow;
    var padding = {
        marginBottom: shouldShow ? '15px' : 0
    };
    return (React.createElement("div", { style: padding },
        React.createElement(MessageBanner, { show: shouldShow, type: "warning" }, t('cross-tenant-message'))));
};
